import { render, staticRenderFns } from "./m_invest018.vue?vue&type=template&id=de967ee0&scoped=true&"
import script from "./m_invest018.vue?vue&type=script&lang=js&"
export * from "./m_invest018.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de967ee0",
  null
  
)

export default component.exports